/* Shared by the preview and its catalog checks. Does not modify inventory. */
(function(root,factory){
 const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.LongvadonProductAvailability=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
 'use strict';
 const keys=['bucket','wrist','adapter','closure','hardware'];
 const available=v=>v.quantity>0||v.inventoryPolicy==='CONTINUE';
 function matching(data,choices,watch){
  const productIds=!data.modelGalleries&&watch?.sourceModel&&watch.bucket===choices.bucket?new Set(data.products.filter(p=>p.model===watch.sourceModel).map(p=>p.id)):null;
  return data.variants.filter(v=>Object.entries(choices).every(([k,value])=>v[k]===value)&&(!productIds||productIds.has(v.productId)));
 }
 // Earlier choices constrain later ones; later choices must not lock out a valid size/model.
 function candidates(data,choices,key,value,watch){
  const index=keys.indexOf(key);if(index<0)return [];
  const prefix=Object.fromEntries(keys.slice(0,index).filter(k=>choices[k]).map(k=>[k,choices[k]]));
  prefix[key]=value;
  return matching(data,prefix,key==='bucket'&&value!==choices.bucket?null:watch).filter(available);
 }
 const canChoose=(data,choices,key,value,watch)=>candidates(data,choices,key,value,watch).length>0;
 function initialChoices(data,{choices={},model='',closure='',variantId='',productId=''}={}){
  const selected=variantId?data.variants.filter(v=>v.id.split('/').pop()===String(variantId)):[];
  if(variantId&&!selected.length)throw Error('This older combination is no longer offered. Choose a new combination from the collection.');
  const entry=data.entryProducts?.find(p=>p.id===productId)||(!data.modelGalleries&&data.products.find(p=>p.id===productId));
  const bucket=model||entry?.bucket,kind=closure||entry?.closure;
  const context={...(bucket?{bucket}:{}),...(kind?{closure:kind}:{}),...choices};
  let pool=data.variants.filter(v=>Object.entries(context).every(([k,value])=>v[k]===value));
  if(!pool.length&&Object.keys(context).length)throw Error('This product selection is no longer offered. Please choose another combination.');
  if(!pool.length)pool=data.variants;
  // An explicit variant keeps its physical SKU, even when out of stock. Its
  // watch bucket can be shared; retain the collection/URL context when possible.
  const explicit=selected.find(v=>pool.includes(v))||selected[0];
  const ranked=[...pool].sort((a,b)=>Number(available(b))-Number(available(a))||Number(b.productId===productId)-Number(a.productId===productId)||Number(b.closure==='Clasp')-Number(a.closure==='Clasp')||Number(b.bucket==='Large')-Number(a.bucket==='Large')||Number(['M','S'].includes(b.wrist))-Number(['M','S'].includes(a.wrist))||Number(b.hardware==='Polished Silver')-Number(a.hardware==='Polished Silver'));
  const pick=explicit||ranked[0];if(!pick)throw Error('No product choices are available.');
  return Object.fromEntries(keys.map(k=>[k,pick[k]]));
 }
 function select(data,choices,key,value,watch){
  let pool=candidates(data,choices,key,value,watch);if(!pool.length)return null;
  const next={...choices,[key]:value};
  for(const field of keys.slice(keys.indexOf(key)+1)){
   const retained=pool.filter(v=>v[field]===next[field]);
   if(retained.length)pool=retained;
   else{next[field]=pool[0][field];pool=pool.filter(v=>v[field]===next[field]);}
  }
  return next;
 }
 return {keys,available,matching,canChoose,select,initialChoices};
});
